import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installFastTooltips } from './utils/fastTooltip';

// Every `title="..."` in the app becomes a ~70ms tooltip instead of the
// browser's ~1s one. One delegated listener, installed before React mounts;
// components keep using plain `title` and nothing opts in. See
// utils/fastTooltip.js (opt out with `data-native-title`).
installFastTooltips();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
